import { useMemo, useState } from "react";
import { t } from "ttag";

import { useListDashboardsQuery } from "metabase/api";
import { LoadingAndErrorWrapper } from "metabase/common/components/LoadingAndErrorWrapper";
import { getIcon } from "metabase/lib/icon";
import { useSelector } from "metabase/lib/redux";
import * as Urls from "metabase/lib/urls";
import { getUser } from "metabase/selectors/user";
import type { Dashboard } from "metabase-types/api";

import { isWithinWeeks } from "../../utils";
import { HomeCaption } from "../HomeCaption";
import { HomeHelpCard } from "../HomeHelpCard";
import { HomeModelCard } from "../HomeModelCard";

import {
  SectionBody,
  PaginationWrapper,
  PageButton,
} from "./HomeDashboardSection.styled";

const ITEMS_PER_PAGE = 8;

export const HomeDashboardSection = () => {
  const { data, isLoading, error } = useListDashboardsQuery();
  const user = useSelector(getUser);

  const hasHelpCard =
    user != null && user.is_installer && isWithinWeeks(user.first_login, 2);

  const [currentPage, setCurrentPage] = useState(1);

  if (isLoading || error) {
    return <LoadingAndErrorWrapper loading={isLoading} error={error} />;
  }

  // ⚠️ IMPORTANT: dashboards ziko ndani ya data.data
  const dashboards: Dashboard[] = data ?? [];

  console.log(data)

  const totalPages = Math.ceil(dashboards.length / ITEMS_PER_PAGE);

  const paginatedDashboards = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    const end = start + ITEMS_PER_PAGE;
    return dashboards.slice(start, end);
  }, [dashboards, currentPage]);

  return (
    <div>
      <HomeCaption>{t`Dashboards`}</HomeCaption>

      <SectionBody>
        {paginatedDashboards.map(dashboard => (
          <HomeModelCard
            key={dashboard.id}
            title={dashboard.name}
            icon={getIcon({ model: "dashboard" })}
            url={Urls.dashboard({ id: dashboard.id, name: dashboard.name })}
          />
        ))}

        {hasHelpCard && <HomeHelpCard />}
      </SectionBody>

      {totalPages > 1 && (
        <PaginationWrapper>
          <PageButton
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(p => p - 1)}
          >
            {t`Previous`}
          </PageButton>

          <span>
            {currentPage} / {totalPages}
          </span>

          <PageButton
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(p => p + 1)}
          >
            {t`Next`}
          </PageButton>
        </PaginationWrapper>
      )}
    </div>
  );
};
